import React from "react";
import { CheckboxTaskView as CoreView } from "@jelly/lesson";

import defaultStyle from "./CheckboxTaskView.module.scss";

export const CheckboxTaskView: React.FC<React.ComponentProps<typeof CoreView>> = (props) => {
  return <CoreView {...props} style={defaultStyle} />;
};
